import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { loadState } from './localStorage';
import reducer from './reducers';

const persistedState = loadState();

export default createStore(reducer, persistedState, applyMiddleware(thunk));
